import { useMemo } from 'react';
import { hasMultipleBillingTerms } from 'pricing-pages-ui-hsoc/components/merch-card-grid/HsocMerchCardPrice';
import { resolveHsocCardBadges } from 'pricing-pages-ui-hsoc/components/merch-card-grid/hsocCardBadges';
import { usePlanQuizState } from 'pricing-pages-ui-hsoc/components/plan-quiz/PlanQuizContext';
import { getRecommendedTierName } from 'pricing-pages-ui-hsoc/components/plan-quiz/planQuizConstants';
import { getPresentHsocTierNames, isHsocTierName } from './hsocPublicTiers';
import { mapProductsByTierToCards } from './hsocPublicCards';
/*
 * Maps shared tier options (owned by the page via useHsocPublicTierOptions, so
 * the tier query, its loading, and its error live in one place) into the merch
 * card props. selectedTerm is controlled by the page so the cards and the
 * feature-table plan-details stay in sync with the billing-term toggle.
 * Mirrors the in-app useHsocInAppPricing.
 */
export function useHsocPublicPricing(tierOptions, currencyCode, selectedTerm) {
  const {
    productsByTier,
    products
  } = tierOptions;
  const tiers = useMemo(() => {
    if (!productsByTier) {
      return [];
    }
    return getPresentHsocTierNames(productsByTier).map(tierName => ({
      tierName,
      productApiName: productsByTier[tierName].productApiName
    }));
  }, [productsByTier]);
  const {
    recommendation
  } = usePlanQuizState();
  const recommendedTierName = useMemo(() => {
    if (!recommendation) {
      return undefined;
    }
    const tierName = getRecommendedTierName(recommendation);
    return isHsocTierName(tierName) ? tierName : undefined;
  }, [recommendation]);
  const badgesByTierName = useMemo(() => resolveHsocCardBadges({
    tiers,
    serverBadgeNameByApiName: {},
    recommendedTierName
  }), [tiers, recommendedTierName]);
  const cards = useMemo(() => mapProductsByTierToCards(productsByTier, products !== null && products !== void 0 ? products : {}, currencyCode, selectedTerm, badgesByTierName), [productsByTier, products, currencyCode, selectedTerm, badgesByTierName]);
  const showTermToggle = useMemo(() => hasMultipleBillingTerms(productsByTier), [productsByTier]);
  return {
    cards,
    showTermToggle
  };
}